import { render, staticRenderFns } from "./TrafficManagementLetterPage.vue?vue&type=template&id=29cd9730&"
import script from "./TrafficManagementLetterPage.vue?vue&type=script&lang=ts&"
export * from "./TrafficManagementLetterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29cd9730')) {
      api.createRecord('29cd9730', component.options)
    } else {
      api.reload('29cd9730', component.options)
    }
    module.hot.accept("./TrafficManagementLetterPage.vue?vue&type=template&id=29cd9730&", function () {
      api.rerender('29cd9730', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Letter/TrafficManagementLetterPage.vue"
export default component.exports